import type { CartExperimentState } from '@/types/cart-experiment';
import { getCartSitePolicy } from '@/domain/cart/experiment';

/** 非购物车 PC 页展示侧栏；US 复用真实分桶，小语种从首屏起使用固定新版。 */
export function getCartSidebarPresentation(
  pathname: string,
  isMobile: boolean,
  experiment: CartExperimentState,
  site = 'us',
): 'legacy' | 'v1' {
  return !isMobile &&
    pathname !== '/cart' &&
    getCartSitePolicy(site, experiment).experience === 'v1'
    ? 'v1'
    : 'legacy';
}
